<template>
  <Select
    v-model="inGamePrice"
    :options="inGameOptions"
    option-label="name"
    option-value="value"
    :loading="loading"
    :show-clear="true"
    :input-class="$style.inputClass"
    @update:model-value="handleUpdate"
  >
    <template #value>
      <div :class="$style.optionRow">
        <img
          v-if="selectedValueFormatted?.sprite?.icon"
          :class="$style.itemIconWithinField"
          :src="selectedValueFormatted?.sprite?.icon"
          :alt="selectedValueFormatted?.sprite?.alt"
        />
        <VdIcon
          v-else-if="inGamePrice"
          store="fa"
          name="image-slash"
          size="large"
          :class="$style.itemIconWithinField"
        ></VdIcon>
        <span>
          {{ selectedValueFormatted.name }}
        </span>
      </div>
    </template>

    <template #option="slotProps">
      <div :class="$style.optionRow">
        <img
          v-if="slotProps.option?.sprite?.icon"
          :class="$style.itemIcon"
          :src="slotProps.option?.sprite?.icon"
          :alt="slotProps.option?.sprite?.alt"
        />
        <VdIcon v-else store="fa" name="image-slash" size="large" :class="$style.itemIcon"></VdIcon>
        <span>
          {{ slotProps.option.name }}
        </span>
      </div>
    </template>
  </Select>
</template>
<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { useGetStoreItemsQuery, StoreItemTypeEnum } from "@/graphql";
import Select from "primevue/select";
import { computed, ref } from "vue";

const props = defineProps({
  gameId: {
    type: String,
    required: true,
  },
  versionId: {
    type: String,
    required: true,
  },
  modelValue: {
    type: String,
    required: true,
  },
});
const emits = defineEmits(["update"]);

const inGamePrice = ref(props.modelValue);

const { result: storeItems, loading } = useGetStoreItemsQuery({
  gameId: props.gameId,
  versionId: props.versionId,
});

const inGameOptions = computed(
  () =>
    storeItems.value?.getStoreItems
      ?.filter((item) => item.type === StoreItemTypeEnum.Currency)
      .map((item) => ({
        name: item.name,
        value: item.id,
        sprite: {
          icon: item.sprite?.imageUrl ?? null,
          alt: item.sprite?.name ?? null,
        },
      })) ?? []
);

const selectedValueFormatted = computed<{
  sprite: {
    icon: string | null;
    alt: string | null;
  };
  name: string;
}>(() => {
  const selectedItem = inGameOptions.value.find((item) => item.value === inGamePrice.value);
  return {
    sprite: {
      icon: selectedItem?.sprite.icon ?? null,
      alt: selectedItem?.sprite.alt ?? null,
    },
    name: selectedItem?.name ?? "Select an item",
  };
});

const handleUpdate = (value: string) => {
  emits("update", {
    id: value,
  });
};
</script>
<style module lang="scss">
.inputClass {
  max-width: 150px;
}
.selectedValue {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.optionRow {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.itemIcon {
  height: 24px;
  width: 24px;
}

.itemIconWithinField {
  height: 16px;
  width: 16px;
}
</style>
